export default {
  'customer.id': 'customerId',
  'card.card_holder': 'cardHolder',
  'card.pan': 'paymentAccount',
  'card.token': 'paymentAccount',
  'payment.account': 'paymentAccount',
};
